import { useMutation, useQueryClient } from 'react-query';
import { createPwdForBI } from 'RestAPIs/admin';
import { showSnackbar } from 'components/shared/index';
import { useTranslation } from 'react-i18next';

const useSavePwdForBI = () => {
  const { t } = useTranslation('common');
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(createPwdForBI, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['business-intelligence', 'password']
      });
      showSnackbar({
        message: t('databaseBIUserSettings.saveSuccess'),
        severity: 'success'
      });
    },
    onError: () => {
      showSnackbar({
        severity: 'error',
        message: t('databaseBIUserSettings.saveError')
      });
    }
  });

  return { mutate, isLoading };
};

export default useSavePwdForBI;
